// extracted by mini-css-extract-plugin
module.exports = {"coupon":"styles_coupon__GCCe1"};